import * as Yup from "yup";

export const cancelReasonSchema = Yup.object().shape({
  motivoCancelamento: Yup.string()
    .notRequired()
    .test(
      "min-if-filled",
      "Descrição deve ter pelo menos 3 caracteres",
      (value) => {
        if (!value) return true;
        return value.trim().length >= 3;
      }
    ),
});
